var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-8",attrs:{"fluid":""}},[(_vm.loaded)?_c('div',[_c('EntitiesList',{attrs:{"title":"Known Entities","columns":_vm.columns,"item":_vm.item}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }